import React from 'react';
import defaultLocales from 'globals/locales/default';
import FsDefaultDialog from 'ui-elements/modals/FsDefaultDialog';
import { FsHelperDialogProps } from 'ui-elements/modals/FsDefaultDialog/FsDefaultDialog';
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
  Switch,
} from '@material-ui/core';
import { UserBillingType, UserRole } from 'globals/types';
import { sentenceCase } from 'globals/utils';
import { useAppContext } from 'contexts/AppContext';

type FsFlagsModalProps = FsHelperDialogProps;

const FsFlagsModal: React.FC<FsFlagsModalProps> = (props) => {
  const {
    userRole,
    setUserRole,
    isUpgraded,
    setIsUpgraded,
    isVerified,
    setIsVerified,
    isPaymentMethodIssue,
    setIsPaymentMethodIssue,
    isSubscribed,
    setIsSubscribed,
    isTrial,
    setIsTrial,
    isBlocked,
    setIsBlocked,
    userBillingType,
    setUserBillingType,
  } = useAppContext();

  const handleRoleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newRole = (event.target as HTMLInputElement).value as UserRole;
    setUserRole(newRole);
  };

  const handleBillingTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newBillingType = (event.target as HTMLInputElement)
      .value as UserBillingType;
    setUserBillingType(newBillingType);
  };

  const flagsState = {
    isUpgraded,
    isPaymentMethodIssue,
    isSubscribed,
    isTrial,
    isBlocked,
    isVerified,
  };

  const handleFlagsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    switch (name) {
      case 'isUpgraded':
        setIsUpgraded(checked);
        break;
      case 'isVerified':
        setIsVerified(checked);
        break;
      case 'isPaymentMethodIssue':
        setIsPaymentMethodIssue(checked);
        break;
      case 'isSubscribed':
        setIsSubscribed(checked);
        break;
      case 'isTrial':
        setIsTrial(checked);
        break;
      case 'isBlocked':
        setIsBlocked(checked);
        break;
      default:
        break;
    }
  };

  return (
    <FsDefaultDialog {...props}>
      <Box mb={2}>
        <FormControl component="fieldset">
          <FormLabel component="legend">{defaultLocales.role}</FormLabel>
          <RadioGroup
            row
            aria-label="role"
            name="role"
            value={userRole}
            onChange={handleRoleChange}
          >
            {Object.values(UserRole).map((role) => (
              <FormControlLabel
                key={role}
                value={role}
                control={<Radio />}
                label={defaultLocales.enums[role]}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
      <Box mb={2}>
        <Divider />
      </Box>
      <Box mb={2}>
        <FormControl component="fieldset">
          <FormLabel component="legend">{defaultLocales.billingType}</FormLabel>
          <RadioGroup
            row
            aria-label="billingType"
            name="billingType"
            value={userBillingType}
            onChange={handleBillingTypeChange}
          >
            {Object.values(UserBillingType).map((billingsType) => (
              <FormControlLabel
                key={billingsType}
                value={billingsType}
                control={<Radio />}
                label={defaultLocales.enums[billingsType]}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
      <Box mb={2}>
        <Divider />
      </Box>
      <Box>
        <FormControl component="fieldset">
          <FormLabel component="legend">{defaultLocales.flags}</FormLabel>
          <FormGroup>
            {Object.entries(flagsState).map(([flagName, flagValue]) => (
              <FormControlLabel
                key={flagName}
                control={
                  <Switch
                    checked={flagValue}
                    onChange={handleFlagsChange}
                    name={flagName}
                  />
                }
                label={sentenceCase(flagName).toUpperCase()}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Box>
    </FsDefaultDialog>
  );
};

export default FsFlagsModal;
